<template>
  <div class="input-wrap">
    <div class="tools">
      <img
        src="@/assets/app/emoji.png"
        alt=""
        class="tool-icon"
        @click="expression = !expression"
      />
      <el-upload
        class="upload-demo"
        action="#"
        :show-file-list="false"
        :limit="1"
        :before-upload="sendImageMessage"
      >
        <img src="@/assets/app/pic.png" alt="" class="tool-icon" />
      </el-upload>
       <img
        src="@/assets/app/expert.png"
        alt=""
        class="tool-icon"
        @click="openTool('expert')"
      />
    </div>
    <div class="input-area-box">
      <el-input
        type="textarea"
        placeholder="请输入内容"
        v-model="textInput"
        :rows="4"
        resize="none"
      >
      </el-input>
    </div>

    <div class="send-wrap">
      <div
        v-if="conversation.conversationID"
        class="send-btn"
        @click="Sendamessage"
      >
        发送
      </div>
    </div>
    <div class="emojo-mask" v-if="expression" @click="expression = false">
      <div class="emojo-wrap">
        <img
          v-for="(item, index) in emojiName"
          :key="index"
          class="emojo-icon"
          @click.stop="changeEmojo(item)"
          :src="emojiUrl + emojiMap[item]"
          alt=""
        />
      </div>
    </div>
  </div>
</template>
<script>
import { emojiName, emojiMap, emojiUrl } from "../../../base/emojiMap";
export default {
  props: {
    conversation: {
      tpye: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      textInput: "",
      expression: false,
      emojiName: emojiName,
      emojiMap: emojiMap,
      emojiUrl: emojiUrl,
      Demandbox: false,
      coach_id: [],
      NeedList: [],
      total: 0,
      currentPage: 1,
    };
  },
  mounted() {},
  methods: {
    openTool(v){
      this.$emit('openTool',v)
    },
    changeEmojo(item) {
      this.textInput = this.textInput + item;
      this.expression = false;
    },
    Sendamessage() {
      if (!this.textInput) {
        return;
      }
      const message = this.$tim.createTextMessage({
        to: this.conversation.toAccount,
        conversationType: this.conversation.type || this.$tims.TYPES.CONV_C2C,
        payload: {
          text: this.textInput,
        },
      });
      //   console.log(message);
      this.$sendMessage(message);
    },
    sendImageMessage(file) {
      const message = this.$tim.createImageMessage({
        to: this.conversation.toAccount,
        conversationType: this.conversation.type || this.$tims.TYPES.CONV_C2C,
        payload: {
          file: file,
        },
      });
      
      this.$sendMessage(message);
      return false;
    },
    sendCustomMessage(payload) {
      const message = this.$tim.createCustomMessage({
        to: this.conversation.toAccount,
        conversationType: this.conversation.type || this.$tims.TYPES.CONV_C2C,
        payload: payload
      });
      
      this.$sendMessage(message);
      return false;
    },
    $sendMessage(message) {
      if (this.conversation.type == "CUSTOMER") {
        message.conversationID = this.conversation.conversationID;
      }
      // console.log(message);
      this.$tim
        .sendMessage(message)
        .then((res) => {
          this.$emit("sendMessage", res);
          this.textInput = "";
          this.expression = false;
          this.Demandbox = false;
        })
        .catch((error) => {});
    },
  },
};
</script>
<style lang="less" scoped>
.input-wrap {
  border-top: 1px solid #eee;
  padding: 12px 20px;
  position: relative;
}
.tools {
  display: flex;
  .tool-icon {
    width: 26px;
    height: 26px;
    margin-right: 20px;
  }
}

.input-area-box {
  margin: 10px 0;
}

.send-wrap {
  display: flex;
  justify-content: flex-end;
}

.emojo-mask {
  position: absolute;
  left: 0;
  top: 0;
  background-color: #eeeeee10;
  width: 100%;
  height: 100%;
}
.emojo-wrap {
  background-color: #ffffff;
  width: 80%;
  height: 100%;
  padding: 20px;
  overflow-y: scroll;
  box-sizing: border-box;
  .emojo-icon {
    width: 30px;
    height: 30px;
    margin: 0 5px 5px;
  }
}

.tool {
  width: 100%;
  position: relative;
}
.send-btn {
  width: 100px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 14px;
  color: #ffffff;
  background-color: #fc7819;
  margin-left: 20px;
  border-radius: 4px;
  cursor: pointer;
}
.e-btn {
  width: 40px;
  height: 40px;
  margin-left: 20px;
}
</style>